import React from 'react';
import { Row } from 'antd';
import logo from '../../assets/images/logo_black.svg';

function SurveyHeader() {
	return (
		<Row type='flex' justify='center' className="SurveyHeader">
			<a href="/">
				<img alt={'logo'} src={logo}/>
			</a>
		</Row>
	);
}

export default SurveyHeader;






// WEBPACK FOOTER //
// ./src/components/SurveyHeader/SurveyHeader.js